import { Component, computed, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MerchantContextService } from "app/core/auth/services";
import { SessionService } from "app/core/services/session.service";

@Component({
  selector: "app-merchant-selector",
  standalone: true,
  templateUrl: "./merchant-selector.component.html",
  styleUrl: "./merchant-selector.component.scss",
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
})
export class MerchantSelectorComponent {
  private _sessionService = inject(SessionService);
  private _merchantContext = inject(MerchantContextService);

  // network.merchants[] lo puebla merchantGuard (SECURITY_UX/session/auth)
  // antes de que se renderice cualquier pantalla protegida.
  merchants = computed(() => this._sessionService.userInfo()?.network?.merchants ?? []);
  selectedMerchantId = computed(() => this._merchantContext.selected()?.id ?? null);

  // Con un solo merchant no tiene sentido mostrar un combo: ya viene auto-seleccionado.
  hasChoice = computed(() => this.merchants().length > 1);

  selectedMerchantLabel = computed(() => {
    const selected = this.merchants().find((item) => item.id === this.selectedMerchantId());
    const merchant = selected ?? this.merchants()[0];
    return merchant?.tradeName || merchant?.name || "";
  });

  onChange(merchantId: string): void {
    const merchant = this.merchants().find((item) => item.id === merchantId);
    if (merchant) {
      this._merchantContext.select({
        id: merchant.id,
        name: merchant.tradeName || merchant.name,
      });
    }
  }
}
